var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"company-image",style:({
        width: _vm.width,
        height: _vm.height,
        maxHeight: _vm.maxHeight,
        maxWidth: _vm.maxWidth
    }),attrs:{"src":_setup.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }